import { useHandler } from "@redotech/react-util/hook";
import { useTranslation } from "@redotech/redo-i18n";
import type { MerchantReviewBeforeFilingState } from "@redotech/redo-return-core-common/return-flow-step-valid";
import {
  StepId,
  StepTypeDetailsProps,
} from "@redotech/redo-return-ui/flows/step";
import { Divider } from "@redotech/redo-web/arbiter-components/divider/divider";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const MerchantReviewBeforeFilingDetails = memo(
  function MerchantReviewBeforeFilingDetails({
    stepSelect,
    state,
    setState,
  }: StepTypeDetailsProps<MerchantReviewBeforeFilingState>) {
    const { t } = useTranslation();
    const nextStepChange = useHandler((next: StepId | undefined) => {
      setState((state) => ({ ...state, next }));
    });

    return (
      <>
        <Flex dir="column" gap="xs">
          <Text fontSize="xs" fontWeight="regular" textColor="secondary">
            {t(
              "{{productName}} claims that reach this step are not filed with {{brandName}}'s insurance provider right away. You review each one and choose to approve and file it, or approve it and handle it yourself. Once any item in a claim reaches this step, the whole claim waits for your review.",
              { productName: "Package Protection Plus", brandName: "Redo" },
            )}
          </Text>
          <Text fontSize="xxs" fontWeight="regular" textColor="secondary">
            {t(
              "Claims must be filed within the insurance provider's filing window, so review held claims promptly.",
            )}
          </Text>
        </Flex>
        <Divider />
        <Flex dir="column" gap="xs">
          <Text fontSize="xs" fontWeight="medium" textColor="secondary">
            {t("Next step")}
          </Text>
          {stepSelect({ value: state.next, valueChange: nextStepChange })}
          {!state.next && (
            <Text fontSize="xs" textColor="error">
              {t("Required")}
            </Text>
          )}
        </Flex>
      </>
    );
  },
);
